import config from "../config/environment";

const apiPaths = {
  // Base URLs - now from environment configuration
  BASE_URL: config.apiBaseUrl,
  CONTENT_BASE_URL2: config.contentApiV1Url,
  CONTENT_BASE_URL: config.contentBaseUrl,
  CONTENT_BASE_URL3: config.contentApiUrl,

  // Endpoint paths
  DASHBOARD_FEED: "/retrieveDashboardFeedContents",
  CAPTURE_CONTENT: "/captureContentResponse",
  ONBOARD_SCHOOL: "/onboardSchool",
  GET_USER: "/getUser",
  SCHOOL_DETAIL: "/school/hierarchy",
  HELP_SUPPORT: "email/HelpContactSupport",
  GET_GROUPS: "/groups/class",
  CREATE_GROUP: "/handleSaveGroup",
  ASSIGN_STORIES: "/handleAssignStories",

  // Student-facing story API (use apiClient2)
  RETRIEVE_STORY: "v3/retrieveStory",
  POST_STORY_UPDATE: "v3/updateStory",
  RETRIEVE_TEMPLATE_LIST: "retrieveTemplates",

  // Breathe / Calm-corner activity API (use apiClient2)
  FETCH_BREATHE_MODULE: "retrieveActivity?activityName=CalmCorner",
  FETCH_BREATHE_LETS_DANCE: "retrieveActivity?activityName=LetsDance",
  FETCH_BREATHE_CALM_MUSIC: "retrieveActivity?activityName=CalmMusic",
  FETCH_TALK_TO_SOMEONE: "retrieveGrownUp",

  // Doodling activity (use apiClient2)
  POST_DOODLE: "v3/captureDoodle",
  GET_COLOUR_SHEETS: "getDoodles",

  // Kids Journal (use apiClient2)
  RETRIEVE_CONTENT_JOURNAL: "retrieveContent/Journal",
  CAPTURE_CONTENT_RESPONSE: "v3/captureContentResponse",

  // Jokes (use apiClient2)
  RETRIEVE_JOKE: "v1/joke",

  // Chat / Tell-a-story (use apiClient2)
  RETRIEVE_CONTENT_CHAT: "retrieveContent/Chat",
  RETRIEVE_CONTENT_STORY: "retrieveContent/Story",

  // Heart Corner (use apiClient2)
  UPDATE_HEART_CORNER: "updateHeartConvoWithEmotion",

  // Quest (use apiClient2)
  RETRIEVE_QUEST: "retrieveQuest",
  POST_QUEST:     "captureQuestResponse",

  //Story break school questions (use apiClient2)
  FETCH_SEL_QUESTIONS: "v1/selQuestions",
  POST_SEL_QUESTIONS: "v1/captureSELPulse",

  // Magic Backpack (use apiClient2)
  GET_MAGIC_BACKPACK_VIDEO: "retrieveMagicBackPack/Video",
  GET_MAGIC_BACKPACK_AUDIO: "retrieveMagicBackPack/Audio",
  GET_MAGIC_BACKPACK_IMAGE: "retrieveMagicBackPack/Image",
  GET_MAGIC_BACKPACK_BOOK: "retrieveMagicBackPack/Book",
  UPDATE_WALL_VIDEO_SEEN: "updateMagicBackPack/Video",
  UPDATE_WALL_AUDIO_SEEN: "updateMagicBackPack/Audio",

  // Room background CDN URLs (tablet/web versions — each room has its own fixed background)
  YARDROOM_TEMPLATE_TAB:
    "https://assets.prod.yetimyfriend.com/Outdoor_acbd7be6cf.png",
  HOMEROOM_TEMPLATE_TAB:
    "https://assets.prod.yetimyfriend.com/Home_Page_tab_f1a663c675.png",
  PLAYROOM_TEMPLATE_TAB:
    "https://assets.prod.yetimyfriend.com/Play_tablet_c3c7be45ec.png",
  CALMROOM_TEMPLATE_TAB:
    "https://assets.prod.yetimyfriend.com/Calmroom_Tab_ca51f86f1a.png",
  YARDROOM_HOME_OBJECT:
    "https://assets.prod.yetimyfriend.com/Home_184ff3006f.json",

  // Chat with Troo 
  CHAT_CONVERSATIONS: 'v1/chatConversations',
  CHAT_QUESTIONS: 'v1/chatQuestions',
  CHAT_RESPONSE: 'v1/chatResponse',

  // Media token refresh (signed-URL remint)
  REMINT_MEDIA: "v1/media/remint",

  GET_RESOURCES: "/resources",
  GET_EMERGING_CHARACTERISTICS: "/characterStrengthWeakness/student",
  GET_ACTIVITIES: "/activities",
  GET_TROO_STORIES: "/selStories/teacher",
};

export default apiPaths;
